import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { setCommonData } from '../reduxToolkit/commonDataSlice'

export default function CommonDataInitializer({ defaultData }) {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(setCommonData(defaultData))
  }, [dispatch, defaultData])
  return null
}
